<template>
<div id="container" class="container frontpage">
    <top-menu />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <!-- Parallax scene  -->
    <button style="display:none" id="startaudioButton" @click="startAudio" ref="startButton">startaudio</button>
    <div id="scene" v-on:click="clearAllHugis"> <!-- data-friction-x="0.1" data-friction-y="0.1" data-scalar-x="4" data-scalar-y="2" -->
      <div class="himmel z1">
          <img src="/static/assets/frontpage/Ausgabe3/Himmel.png" />
      </div>
      <div class="background3 wolken_animation z1">
        <img src="/static/assets/frontpage/Ausgabe3/Wolken.png" />
      </div>
      <div class="background1 z5">
        <img src="/static/assets/frontpage/Ausgabe3/Vorderer_Hintergrund.png" />
      </div>
      <!-- <div data-depth="0.3" class="buesche2 z13">
        <div class="inner">
              <img class="buesche2img" src="/static/assets/frontpage/Buesche_2.png" />
        </div>
      </div> -->
    </div>

    <!--div class="startaudio" v-if="!autoplay">
      <img src="/static/assets/alle/sound_off.png" @click="startAudio"/>
    </div>
    <div class="startaudio" v-if="autoplay">
      <img src="/static/assets/alle/sound.png" @click="stopAudio"/>
    </div -->
    <!-- front layer static -->
    <div class="dubix z44 pointer" data-depth="0.4">
        <div class="inner">
          <div class="dubix_animation pointer" @click="toggleDubix"></div>
        </div>
    </div>
    <transition name="fade">
      <div class="dubixsprech z100" v-if="dubixshow" @click="toggleDubix">
        <img src="/static/assets/frontpage/Dubix_sprech.png" />
        <p>Das ist Dubix. Dubix ist Gigis und Hugis großer Cousin und das Herrchen von Libero. Die vier wohnen nur zwei Straßen entfernt und stecken jeden Tag zusammen. Dubix liest seine Abenteuer-Geschichten immer zuerst Libero vor, denn er ist ein guter<br />Zuhörer.</p>
      </div>
    </transition>
    <div class="hui z44 pointer" data-depth="0.3">
        <div class="inner">
          <div class="hui_animation pointer" @click="toggleHui"></div>
                <transition name="fade">
                  <div class="huisprech z100" v-if="huishow"  @click="toggleHui">
                    <img src="/static/assets/frontpage/Hui_sprech.png" />
                    <p>Das ist Hugi. Hugi ist Gigis kleiner Bruder. Er findet seine mutige Schwester ziemlich cool. Wenn sie gar so schlau tut, nervt sie aber. Als er noch klein war, hat Gigi ihm viel vorgelesen. Jetzt erfindet Hugi schon eigene Abenteuer!</p>
                  </div>
                </transition>
        </div>
    </div>
    <div class="gigi z44 pointer" data-depth="0.2" id="gigi_home">
      <div class="inner">
        <div class="gigi_animation pointer" @click="toggleGigi"></div>
        <transition name="fade">
          <div class="gigisprech z100" v-if="gigishow" @click="toggleGigi">
            <img  src="/static/assets/frontpage/Gigi_sprech.png" />
            <p>Das ist Gigi. Gigi konnte schon mit drei Jahren lesen, behauptet Dubix. Stimmt aber nicht! Wahr ist, dass es für Gigi nichts Schöneres als Bücher gibt. Wenn sie groß ist, will sie Buchhändlerin werden und Kindern die allerbesten Bücher verkaufen.</p>
          </div>
        </transition>
      </div>
    </div>
    <div class="libero z43 pointer" data-depth="0.2">
        <div class="inner">
          <div class="libero_animation pointer" @click="toggleLibero"></div>
        </div>
    </div>
    <transition name="fade">
      <div v-if="liberoshow"  class="liberosprech z100" @click="toggleLibero">
        <img src="/static/assets/frontpage/Libero_sprech.png"/>
        <p>Das ist Libero. Libero liebt Würstchen und Dubix. Würstchen, weil sie lecker schmecken, und Dubix, weil er so ruhig ist und alles gut überlegt. Natürlich mag er auch Gigi und Hugi. Auf Hugi muss er aber höllisch aufpassen, tollpatschig wie er ist! Da könnte er Geschichten erzählen!</p>
      </div>
    </transition>

    <div class="wegweiser z25">
      <div class="inner">
        <img src="/static/assets/frontpage/Ausgabe8/Wegweiser.png" usemap="#image-map">

        <map name="image-map">
            <area target="" alt="Archiv" title="Archiv" href="#" coords="205,107,8,18" shape="rect" v-on:click.stop="schildArchiv" />
            <area target="" alt="Olympia" title="Olympia" href="#Olympia" coords="15,172,1,116,180,75,233,104,200,152" shape="poly" v-on:click.stop="schildNinja"/>
            <area target="" alt="Wal" title="Wal" href="#Wal" coords="226,216,217,277,53,278,13,233,13,219,42,204,59,188" shape="poly" v-on:click.stop="schildPferd"/>
            <area target="" alt="Game" title="Game" href="#Game" coords="16,405,9,346,181,304,202,314,232,337,199,390" shape="poly" v-on:click.stop="schildStrom"/>
        </map>
      </div>
    </div>
    <div class="stickerheft_shine rotating z39">
      <img src="/static/assets/frontpage/Logo_Shine.png" />
    </div>
	<!-- <div class="fuchs fuchs_animation z40"></div> -->
	<!-- <div class="mauli mauli_animation z40">
    </div> -->
  <div class="maulwurf maulwurfsprite viecher z20 pointer" v-bind:class="{maulwurf_animation:animateMaulwurf}" v-on:click="aktiviereMaulwurf">
    </div>
	<!-- <div class="schilder schilder_animation z40">
    </div> -->
	<div class="schleimmonster schleimmonster_animation z40 pointer" v-on:click.stop="Monster">
    </div>
	<!-- <div class="vogel vogel_animation z40" v-bind:class="{vogelsprite_animate:animateVogel}" v-on:click="aktiviereVogel"></div> -->
  <div class="vogelsprite z31 pointer" v-bind:class="{vogelsprite_animate:animateVogel}" v-on:click="aktiviereVogel"></div>
	<div class="hugi z40" @click="toggleHui">
		<img src="/static/assets/frontpage/Ausgabe3/Hugi.png" />
    </div>
	<div class="gigi z40" @click="toggleGigi">
		<img src="/static/assets/frontpage/Ausgabe3/Gigi.png" />
    </div>
	<div class="dubix z40" @click="toggleDubix">
		<img src="/static/assets/frontpage/Ausgabe3/Dubix.png" />
    </div>
	<div class="libero z40" @click="toggleLibero">
		<img src="/static/assets/frontpage/Ausgabe3/Libero.png" />
    </div>
    <div  data-depth="0.4" class="stickerheft z41 pointer" id="stickerheft_frontpage">
      <div class="inner">
        <router-link to="/archiv7" tag="img" src="/static/assets/frontpage/Ausgabe8/Album.png" @click="toggleHeft"/>
      </div>
    </div>
    <transition name="bounce">
      <div class="heftsprech" @click="heftSprech"> <!-- v-if="heftshow" @click="heftshow=false" -->
        <img class="stickerheft_wolke z31" src="/static/assets/frontpage/Ausgabe3/textPfeil.png" />
      </div>
    </transition>

    <div class="baum fuchs_animation z30" >
    </div>
    <router-link to="/elterninfo" tag="div" class="elterninfo z50">
      <div class="inner">
            <img class="elterninfoimg z21 pointer" src="/static/assets/frontpage/Elterninfo.png" />
            <img class="elterninforechteck z20 pointer" src="/static/assets/frontpage/Elterninfo_rechteck.png" />
      </div>
    </router-link>
    <router-link to="/" tag="div" class="logo z50 pointer"  data-depth="0.4">
        <div class="inner">
            <img class="img z50" src="/static/assets/frontpage/Logo.png" @click="toggleLogo"/>
            <img class="imgbg z40 rotating" src="/static/assets/frontpage/Logo_Shine.png" />
        </div>
    </router-link>
    <transition name="fade">
      <div class="wolke z40 wippen" v-if="logoshow">
        <div class="inner">
              <img class="imgbg" src="/static/assets/frontpage/Logo_Wolke.png" />
              <img class="text" src="/static/assets/frontpage/freu_dich_auf_abenteuer.png" />
        </div>
      </div>
    </transition>
</div>
</template>

<script>
/* eslint-disable */
import Topmenu from '@/components/Topmenu.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Parallax from 'parallax-js'
import Copyright from '@/components/Copyright.vue'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Frontpage',
  data () {
    return {
      who: 'Frontpage',
      gigishow: false,
      huishow: false,
      liberoshow: false,
      dubixshow: false,
      logoshow: false,
      heftshow: false,
      mute: false,
      animateVogel: false,
      animateMaulwurf: false,
      autoplay: false
    }
  },
  components: {
    'top-menu': Topmenu,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'hintergrundbutton': Hintergrundbutton
  },
  watch: { 
    animateVogel: function (oldval, newval) {
      console.log('watch animateVogel', oldval, newval)
    },
    animateMaulwurf: function (oldval, newval) {
      console.log('watch animateMaulwurf', oldval, newval)
    },
    firstload:  function (oldval, newval) {
      console.log('watch firstload', oldval, newval)
    },
    autoplay: function (oldval, newval) {
      console.log('watch autoplay', newval)
    }
  },
  methods: {
    schildNinja () {
      window.currentAudio = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Gigi_Augia_Klick_V3.mp3')
      window.currentAudio.muted = window.muted
      window.currentAudio.play()
      var self = this
      setTimeout(function() {
        self.$root.$router.push('/olympia')
      },1500);
    },
    schildPferd () {
      window.currentAudio = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Dubix_Beluga_Klick_V3.mp3')
      window.currentAudio.muted = window.muted
      window.currentAudio.play()
      var self = this
      setTimeout(function() {
        self.$root.$router.push('/wal')
      },1500);
    },
    schildStrom () {
      window.currentAudio = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Hugi_Heldenhaft_Klick_V1.mp3')
      window.currentAudio.muted = window.muted
      window.currentAudio.play()
      var self = this
      setTimeout(function() {
        self.$root.$router.push('/game')
      },1500);
    },
    schildArchiv () {
      console.log('schildArchiv')
      window.currentAudio = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Klick_Schild_pur.mp3')
      window.currentAudio.muted = window.muted
      window.currentAudio.play()
      var self = this
      setTimeout(function() {
        self.$root.$router.push('/archiv6')
      },1000);
    },
    Monster () {
      window.currentAudio = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Frontpage_2019_Gullymonster.mp3')
      window.currentAudio.muted = window.muted
      window.currentAudio.play()
      var self = this
    },
    aktiviereVogel () {
      console.log('aktiviereVogel')
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = undefined
        } catch(e) {
          console.log('pause geht nicht', e)
        }
      }
      window.currentAudioV = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Vogel.mp3')
      window.currentAudioV.muted = window.muted
      window.currentAudioV.play()
      this.animateVogel = true
      var self = this
      setTimeout(function () {
        console.log('aktiviereVogel2')
        self.animateVogel = false
      }, 3000)
    },
    aktiviereMaulwurf () {
      console.log('aktiviereMaulwurf')
      window.currentAudio = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Maulwurf.mp3')
      window.currentAudio.muted = window.muted
      window.currentAudio.play()
      this.animateMaulwurf = true
      var self = this
      setTimeout(function () {
        console.log('aktiviereMaulwurf2')
        self.animateMaulwurf = false
      }, 3000)
    },
    clearAllHugis () {
      this.gigishow = false
      this.liberoshow = false
      this.dubixshow = false
      this.logoshow = false
      this.heftshow = false
      this.huishow = false 
      this.stopAlle()
    },
    toggleHui () {
      this.gigishow = false
      this.liberoshow = false
      this.dubixshow = false
      this.logoshow = false
      this.heftshow = false
      this.huishow = !this.huishow
      if (this.huishow) {
        this.stopAlle()
        window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Sprechblase_Hui.mp3')
        window.currentAudioX.muted = this.$root.muted
        window.currentAudioX.play()
      } else {
        this.stopAlle()
      }
    },
    toggleGigi () {
      this.liberoshow = false
      this.dubixshow = false
      this.huishow = false
      this.logoshow = false
      this.heftshow = false
      this.gigishow = !this.gigishow
      if (this.gigishow) {
        this.stopAlle()
        window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Sprechblase_Gigi.mp3')
        window.currentAudioX.muted = this.$root.muted
        window.currentAudioX.play()
      } else {
        this.stopAlle()
      }
    },
    toggleDubix () {
      this.gigishow = false
      this.huishow = false
      this.liberoshow = false
      this.logoshow = false
      this.heftshow = false
      this.dubixshow = !this.dubixshow
        console.log('toggleDubix', this.dubixshow )
      if (this.dubixshow) {
        console.log('dubix anzeigen!')
        this.stopAlle()
        console.log('nach stopalle')
        window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Sprechblase_Dubix.mp3')
        window.currentAudioX.muted = this.$root.muted
        window.currentAudioX.play()
        console.log('started audio hui sprechblase')
      } else {
        this.stopAlle()
      }
    },
    toggleLibero () {
      this.gigishow = false
      this.huishow = false
      this.dubixshow = false
      this.logoshow = false
      this.heftshow = false
      this.liberoshow = !this.liberoshow
      if (this.liberoshow) {
        this.stopAlle()
        window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Timer_abgelaufen_V1.mp3')
        window.currentAudioX.muted = window.muted
        window.currentAudioX.play()
        setTimeout(function () {
          window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Sprechblase_Libero.mp3')
          window.currentAudioX.muted = window.muted
          window.currentAudioX.play()
        }, 1000)
      } else {
        this.stopAlle()
      }
    },
    toggleLogo () {
      this.gigishow = false
      this.huishow = false
      this.dubixshow = false
      this.liberoshow = false
      this.heftshow = false
      this.logoshow = !this.logoshow
      //if (this.logoshow) {
      //  this.stopAlle()
      //  window.currentAudio = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Wolke_1.mp3')
      //  window.currentAudio.muted = this.$root.muted
      //  window.currentAudio.play()
      //  
      //}
    },
    toggleHeft () {
      this.gigishow = false
      this.huishow = false
      this.dubixshow = false
      this.liberoshow = false
      this.logoshow = false
      this.heftshow = !this.heftshow
    },
    heftSprech () {
      //this.stopAlle()
      //muted = (typeof this.$root.muted !== 'undefined'?this.$root.muted : false)
      //window.currentAudio = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Wolke_2.mp3')
      //window.currentAudio.muted = muted
      //window.currentAudio.play()
    },
    stopAlle () {
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = undefined
        } catch(e) {
          console.log('pause geht nicht', e)
        }
      }
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = undefined
        } catch(e) {
          console.log('pause geht nicht', e)
        }
      }
    },
    startAudio () {
      console.log('startAudio')
      try {        
        window.currentAudioX.play()
        console.log('claim gestartet')
      } catch (e) {
        console.log('claim error', e)
      }
      try {
        window.hintergrundSound.play()
        console.log('hintergrundsound gestartet')
        window.bgsounddisabled = false
      } catch (e) {
        console.log('atmo error', e)
        window.bgsounddisabled = true
      }
      this.autoplay = true
    },
    stopAudio () {
      try {
        window.currentAudioX.pause()
        console.log('claim gestartet')
      } catch (e) {
        console.log('claim error', e)
      }
      try {
        window.hintergrundSound.pause()
        console.log('hintergrundsound gestartet')
      } catch (e) {
        console.log('atmo error', e)
      }
      this.autoplay = false
    }
  },
  mounted () {
    this.$ga.page(this.$router)
    this.stopAlle()
    var muted = window.muted
    var scene = document.getElementById('scene')
    // var parallaxInstance = new Parallax(scene, {
    //  pointerEvents: true
    // })
    // parallaxInstance.friction(0.4, 0.4)
    var self = this
    // setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
        } catch (e) {
            console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
        } catch (e) {
            console.log('pause geht nicht')
        }
      }
      if (typeof window.hintergrundSound !== 'undefined') {
        try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
        } catch (e) {
            console.log('pause geht nicht')
        }
      }
      if (typeof window.firstload === 'undefined') window.firstload = true
      if (window.firstload) {
        window.currentAudioX = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Claim.mp3')
        window.currentAudioX.muted = window.muted
        window.currentAudioX.autoplay = true
        // window.currentAudioX.play()
        var promise = window.currentAudioX.play()
        if (promise !== undefined) {
          promise.then(_ => {
            // Autoplay started!
            this.autoplay = true
          }).catch(error => {
            // Autoplay was prevented.
            // Show a "Play" button so that user can start playback.
            this.autoplay = false
          });
        }

        window.firstload = false
      }
      window.hintergrundSound = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Frontpage_Atmo_II.mp3')
      window.hintergrundSound.muted = window.muted
      window.hintergrundSound.loop = true
      window.hintergrundSound.autoplay = true
      if (this.autoplay !== true) {
        var promise = window.hintergrundSound.play()
        if (promise !== undefined) {
          promise.then(_ => {
            // Autoplay started!
            this.autoplay = true
          }).catch(error => {
            // Autoplay was prevented.
            // Show a "Play" button so that user can start playback.
            this.autoplay = false
          });
        }
      }
//      var elem = this.$refs.startButton
//      elem.dispatchEvent(new Event("click"))
//  }, 1000);   
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
      console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
area { outline: 0;}
body {margin:0; padding:0;}

/* Z-Index - Level */

  .container {position: relative; }
.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}
.z100 { z-index: 1000; }
.z1000 { z-index: 100000; }
.z2000 { z-index: 200000; }
.z3000 { z-index: 300000; }
.z4000 { z-index: 400000; }
.z5000 { z-index: 500000; }
.z6000 { z-index: 600000; }
.z7000 { z-index: 700000; }

/*frontpage */
/* level 1 - hintergrund tief */

.frontpage { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.frontpage .himmel { position: absolute; left: 0; width: 100%; height: auto; z-index: -20; margin-left:-25%; }
.frontpage .himmel img { margin-top: -365px; }
.frontpage .background1 { position: absolute; left: -520px !important; top: -256px !important; width: 100%; height: auto;  z-index: -9; transform: scale(1) !important}
.frontpage .background2 { position: absolute; bottom: 0px; left: 0; width: 100%; height: auto; margin-top: 580px; margin-left:-25%; z-index: -7; }
.frontpage .buesche2   { position: absolute; bottom: 19vh; right: 4vh; height: auto; margin-top: 611px; z-index: -7; margin-left: 790px; }
.frontpage .background3 { /* position: absolute; bottom: 0px; left: 0; */ width: 100%; height: auto; margin-top: 0px; margin-left: 0%; z-index: -15; }

/* hintergrund mittel */
.frontpage .wegweiser   { position: absolute; top: 376px; right: 75%; height: auto; }
.frontpage .wegweiser .inner { position: relative; }

.frontpage .stickerheft_shine { position: absolute; top: 9%; right: 74%; z-index: 39;  }
.frontpage .stickerheft { position: absolute; top: 13%; right: 80%;  }
.frontpage .stickerheft .inner { position: relative;}
.stickerheft_wolke { position: absolute; top: 28px; right: 1378px; /*display: none;*/ }
.stickerheft_text { position: absolute; top: 230px; right: 410px; /* display: none;*/ }

.frontpage .stickerheft.active .inner .stickerheft_wolke { display: block;}
.frontpage .stickerheft.active .inner .stickerheft_text { display: block; }
.frontpage .schleimmonster_animation { position: absolute; top: 57%; left: -3%;}
.frontpage .baum { position: absolute; top: -1%; left: 66%; width: 483px; height: 668px; }
.frontpage .baum .inner { position: relative;  }
.frontpage .baum .inner .buschbaumimg  { position: absolute; bottom: -20px; left: 120px; height: auto;  }
.frontpage .maulwurfsprite { position: absolute; top: 79% !important; left: 67% !important; z-index:500 !important;}
.frontpage .vogelsprite { position: absolute; top: 24%; right: 5%; }
.frontpage  .maulwurf { position: absolute; top: 675px; left: 1684px; height: auto;  }
.frontpage  .maulwurf .inner { position: relative; }
.frontpage .hugi {position: absolute; top: 685px !important; left: 430px !important; }
.frontpage .gigi { position: absolute; top: 610px !important; left: 1003px !important; }
.frontpage .dubix { position: absolute; top: 555px !important; left: 700px !important; }
.frontpage .libero { position: absolute; top: 860px !important; left: 710px !important; }
/* class="maulwurd active" -> maulwurf sichtbar, sonst nur hügel */
	
.frontpage  .elterninfo { position: absolute; bottom: 20px; right: 493px; height: auto; }
.frontpage  .elterninfo .inner { position: relative; }
.frontpage  .elterninfo .inner .elterninfoimg{ position: absolute; bottom: 30px; left: 33px;  }
.frontpage  .elterninfo .inner .elterninforechteck{ position: absolute; bottom: 0px; left: 0px;  }

/* .wolke.active klasse setzen und die sprechblase wird sichtbar */
.frontpage  .logo { position: absolute; top: 450px; left: 454px; height: auto; }
.frontpage  .logo .inner { position: relative; }
.frontpage  .logo .inner .img{ position: absolute; bottom: 88px; left: 0px;   }
.frontpage  .logo .inner .imgbg{ position: absolute; bottom: 0px; left: 0px;  }
	
.frontpage .elterninfo { position: absolute; bottom: 20px; right: 493px; height: auto; }
.frontpage .logo .inner .imgbg { position: absolute; bottom: 0; left: 0; }
	
.frontpage .wolke { position: absolute; top: 293px; left: 600px; }
.frontpage .wolke .inner { position: relative; }
.frontpage .wolke .inner .imgbg { position: absolute; top: 0px; left: 0px; }
.frontpage .wolke .inner .text { position: absolute; top: 120px; left: 60px;   }

/* hugidubies */
.frontpage  .gigi { position: absolute;
    top: 480px;
    left: 1020px;
    width: 420px;}
.frontpage .gigi {animation: gigi_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes gigi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.frontpage  .gigi .inner { position: relative;  }
.frontpage  .gigi .inner .gigisprech{ position:absolute; left: -368px; top: -100px;}
.frontpage  .gigi.active .inner .gigisprech { display: block; }

.frontpage  .libero { position: absolute; top: 550px; left: 750px; height: auto;  }
.frontpage .libero {animation: libero_erscheint 0.5s ease-out; animation-delay: 0s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes libero_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}

.frontpage  .libero .inner { position: relative;  }
.frontpage  .liberosprech{ position:absolute;  left: 690px;  top: 360px; height: 439px; }
.frontpage  .liberpsprech img {position: absolute; }
.frontpage  .liberosprech p {
    position: absolute;
    top: 44px;
    left: 55px;
    font-size: 22px;
    font-weight: normal;
    width: 285px;
    font-family: "Open sans", sans-serif;
    line-height: 28px;
}

.frontpage  .hui { position: absolute; top: 600px; left: 370px; height: auto;}
.frontpage .hui {animation: hui_erscheint 0.5s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hui_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.frontpage  .hui .inner { position: relative; }
.frontpage  .hui .inner .huisprech{ /* display: none;*/ position:absolute; left: 300px;  top: -210px; width: 372px; height: 439px; }

.frontpage  .hui .inner .huisprech img {position: absolute; }
.frontpage  .hui .inner .huisprech p {
    position: absolute;
    top: 44px;
    left: 55px;
    font-size: 22px;
    font-weight: normal;
    width: 253px;
    font-family: "Open sans", sans-serif;
    line-height: 28px;
}

.frontpage  .dubix {position: absolute; top: 355px; left: 700px; height: 440px; overflow:hidden;}
.frontpage .dubix {animation: dubix_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.frontpage  .dubix .inner { position: relative; }
.dubixsprech { position:absolute; left: 1000px;  top: 130px;}
.dubixsprech img {position: absolute; }
.dubixsprech p {
    position: absolute;
    top: 44px;
    left: 55px;
    font-size: 22px;
    font-weight: normal;
    width: 260px;
    font-family: "Open sans", sans-serif;
    line-height: 27px;
}

.gigisprech img {position: absolute; }
.gigisprech p {
    position: absolute;
    top: 44px;
    left: 48px;
    font-size: 22px;
    font-weight: normal;
    width: 316px;
    font-family: "Open sans", sans-serif;
    line-height: 28px;
}

@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.frontpage .rotating {
  -webkit-animation: rotating 10s linear infinite;
  -moz-animation: rotating 10s linear infinite;
  -ms-animation: rotating 10s linear infinite;
  -o-animation: rotating 10s linear infinite;
  animation: rotating 10s linear infinite;
}

@-webkit-keyframes wippen /* Safari and Chrome */ {
  0% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  25% {
    -webkit-transform: rotateX(15deg);
    -o-transform: rotateX(15deg);
    transform: rotateX(15deg);
  }
  50% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  75% {
    -webkit-transform: rotateX(-15deg);
    -o-transform: rotateX(-15deg);
    transform: rotateX(-15deg);
  }
  100% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
}
@keyframes wippen {
  0% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  25% {
    -webkit-transform: rotateX(15deg);
    -o-transform: rotateX(15deg);
    -moz-transform: rotateX(15deg);
    transform: rotateX(15deg);
  }
  50% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  75% {
    -webkit-transform: rotateX(-15deg);
    -o-transform: rotateX(-15deg);
    -moz-transform: rotateX(-15deg);
    transform: rotateX(-15deg);
  }
  100% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
}

.frontpage .wippen {
  -webkit-animation: wippen 4s linear infinite;
  -moz-animation: wippen 4s linear infinite;
  -ms-animation: wippen 4s linear infinite;
  -o-animation: wippen 4s linear infinite;
  animation: wippen 4s linear infinite;
}

/* fuchs animation*/
.fuchs_animation {
  width: 1099px !important;
  height: 1093px !important;
  background: url('/static/assets/frontpage/Ausgabe3/Fuchs_Animation.png') top center;
  animation: fuchs_animation 9s steps(7) infinite;
  animation-delay: 1.5s;
  transform: scale(1);
}

@keyframes fuchs_animation {
    0% { background-position: 0 -0px; }
    25% { background-position: 0 -7651px; }
    100% { background-position: 0 -7651px; }
}
/*Wolken Animation*/
.wolken_animation {animation: wolken_erscheint_animation 35s linear infinite; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; position: absolute !important;}
@keyframes wolken_erscheint_animation {
    0% {right: 750px; opacity: 0;}
	20% {opacity: 1;}
	80% {opacity: 1;}
    100% {right: -200px; opacity: 0; }
}
/* mauli animation*/
.mauli_animation {
  width: 217px;
  height: 230px;
  background: url('/static/assets/frontpage/Ausgabe3/Mauli_Animation.png') top center;
  animation: mauli_animation 3s steps(11) infinite;
  animation-delay: 4s;
  transform: scale(0.6);
}

@keyframes mauli_animation {
    100% { background-position: 0 -2530px; }
}
  
/* maulwurf animation*/
.maulwurfsprite {
  width: 217px;
  height: 230px !important;
  background: url('/static/assets/frontpage/Ausgabe3/Mauli_Animation.png') top center;
  transform: scale(0.60);
}

.maulwurf_animation {
  width: 217px;
  height: 230px !important;
  background: url('/static/assets/frontpage/Ausgabe3/Mauli_Animation.png') top center;
  animation: mauli_animation 3s steps(11) infinite;
  transform: scale(0.60);
  /*animation-delay: 8s;*/
}
@keyframes mauli_animation {
    100% { background-position: 0 -2530px; }
}
@keyframes maulwurf_hui {
    0% { background-position: 0 0px; }
    25% { background-position: 0 -4032px; }
    100% { background-position: 0 -4032px; }
}  

/* schilder animation*/
.schilder_animation {
  width: 302px;
  height: 417px;
  background: url('/static/assets/frontpage/Ausgabe3/Schilder_Animation.png') top center;
  animation-delay: 2s;
  animation: schilder_animation 4s steps(4) infinite;
  transform: scale(0.8);
  margin-left:-100px;
}

@keyframes schilder_animation {
    100% { background-position: 0 -1668px; }
}

/* schleimmonster animation*/
.schleimmonster_animation {
  width: 201px;
  height: 135px;
  background: url('/static/assets/frontpage/Ausgabe3/Schleimmonster_Animation.png') top center;
    animation: schleimmonster_animation 15s steps(13) infinite;
  animation-delay: 4s;
}

@keyframes schleimmonster_animation {
    0% { background-position: 0 0px; }
    25% { background-position: 0 -1755px; }
    100% { background-position: 0 -1755px; }
}

/* vogel animation
.vogel_animation {
  width: 156px;
  height: 117px !important;
  background: url('/static/assets/frontpage/Ausgabe3/Vogel_Animation.png') top center;
    animation: vogel_animation 3s steps(9) infinite;
  transform: scale(0.70);
}

*/
.vogelsprite {
  width: 156px;
  height: 117px !important;
    position: absolute;
    display: block !important;
    z-index: 500;
}
.vogelsprite{
  background: url('/static/assets/frontpage/Ausgabe3/Vogel_Animation.png') top center;
  transform: scale(0.70);
 }

.vogelsprite_animate {
  background: url('/static/assets/frontpage/Ausgabe3/Vogel_Animation.png') top center;
    animation: vogel_animation 3s steps(9) infinite;
  transform: scale(0.70);
  /*animation-delay: 10s;*/
}
@keyframes vogel_animation {
    100% { background-position: 0 -1053px; }
}
  
/* heft */  
  
.heftsprech {
    animation: heftsprech 16s infinite;
  animation-delay: 8s;
    opacity:0;
}
@keyframes heftsprech {
    0% { opacity:0; }
    25% { opacity:0; }
    35% { opacity:1; }
    65% { opacity:1; }
    75% { opacity:0; }
    100% { opacity:0; }
}

@keyframes vogelflug {
    0% { background-position: 0 0px; }
    25% { background-position: 0 -1800px; }
    100% { background-position: 0 -1800px; }
}
  .pointer {cursor:pointer;}
.hide { display: none !important; }
.startaudio { position: absolute; left: 412px; bottom: 21px; }
</style>



// WEBPACK FOOTER //
// src/components/Frontpage.vue